import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Chip, CircularProgress, Stack, Typography } from '@mui/material';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import { useDispatch } from 'react-redux';
import { getUserScanner } from '../../../../redux/features/foodSlice';
import { useSelector } from 'react-redux';
import { Icon } from '@iconify/react/dist/iconify.js';

const FoodScanner = ({ open, setOpen }) => {
  const dispatch = useDispatch();

  const { loading, scanner ,error} = useSelector((store) => store.food);

  useEffect(() => {
    if (open) {
      dispatch(getUserScanner());
    }
  }, [open]);

  const [scannerPreview, setScannerPreview] = useState(null);

  useEffect(() => {
    if (scanner) {
      const url = URL.createObjectURL(scanner);
      setScannerPreview(url);

      return () => URL.revokeObjectURL(url); 
    }
  }, [scanner]);

  const handleDownload = () => {
    if (!scanner) return;

    const url = window.URL.createObjectURL(scanner);
    const link = document.createElement('a');

    link.href = url;
    link.download = 'food-scanner.png';

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };
  return (
    <GlobalDialog
      title={'Food Scanner'}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={'xs'}
      closeButton={true}
      content={
        <>
        {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'auto' }}>
            <CircularProgress />
            </Box>
            ) : (
        <Box sx={{ mb: 2 , display:'flex', flexDirection:'column', alignItems:'center' }}>
          <Box
            sx={{
              width: '100%',
              height: '100%',
              border: '1px dashed #ccc',
              borderRadius: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 2,
              backgroundColor: '#fafafa',
            }}
          >
              <img
                src={scannerPreview}
                alt="Food Scanner QR"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                }}
              />
              {error && (
             <Alert severity="warning" variant='outlined'>Scanner not available</Alert>
              )}
          </Box>
                      <Button
              variant="contained"
              onClick={handleDownload}
              disabled={error}
              color="secondary"
              startIcon={<Icon icon={'material-symbols:qr-code-scanner'} />}
            >
              {loading ? 'Preparing...' : 'Download Scanner'}
            </Button>
        </Box>
            )}
        </>
      }
    />
  );
};

export default FoodScanner;
